export default {
  MANUFACTURER: 'MANUFACTURER',
  CONSUMER: 'CONSUMER',
};
